import ModelWithFacilityApi from "./ModelWithFacilityApi";

export default class NewOccupancyApi extends ModelWithFacilityApi {
    constructor(token, clientId, onUnauthorized) {
        super(token, clientId, onUnauthorized);
        this.baseUrl = this.getBaseUrl() + "occupancy2/";
    }

    listOccupancyPoints(facility, onSuccess, onError) {
        const endPoint = `${this.baseUrl}occupancy_points/`;

        this.Get(
            endPoint + `?facility=${facility.split("/").slice(-2)[0]}`,
            onSuccess,
            onError,
        );
    }

    getOccupancyTrends(
        facility,
        fromDate,
        toDate,
        timeAgg,
        onSuccess,
        onError,
    ) {
        const endPoint = this.baseUrl + "trends/";

        let data = {
            facility: facility ? facility.split("/").slice(-2)[0] : undefined,
            from_date: fromDate.toISOString().split("T")[0],
            to_date: toDate.toISOString().split("T")[0],
            time_agg: timeAgg,
        };

        this.Post(endPoint, data, onSuccess, onError);
    }
}
